import React from 'react';
import { FaPlus, FaTrashAlt } from 'react-icons/fa';

function StudioItemForm({
  itemForm,
  taxonomies,
  onChange,
  onArrayFieldChange,
  onLinkChange,
  onVideoChange,
  onAddLink,
  onRemoveLink,
  onAddVideo,
  onRemoveVideo,
  onSubmit,
  onReset,
  isEditing,
  busy,
}) {
  return (
    <form className="studio-panel studio-panel--form" onSubmit={onSubmit}>
      <div className="studio-panel__heading">
        <div>
          <span className="section-label">Item Editor</span>
          <h3>{isEditing ? 'Update portfolio item' : 'Add new portfolio item'}</h3>
        </div>

        {isEditing ? (
          <button type="button" className="studio-button studio-button--ghost" onClick={onReset}>
            Create new instead
          </button>
        ) : null}
      </div>

      <div className="studio-form-grid">
        <label>
          <span>Title</span>
          <input
            type="text"
            name="title"
            value={itemForm.title}
            onChange={onChange}
            placeholder="Wardrobe AI, Smart Mirror, Client Portal..."
          />
        </label>

        <label>
          <span>Collection</span>
          <select name="collection" value={itemForm.collection} onChange={onChange}>
            {taxonomies.collections.map((collection) => (
              <option key={collection} value={collection}>
                {collection}
              </option>
            ))}
          </select>
        </label>

        <label>
          <span>Category</span>
          <select name="category" value={itemForm.category} onChange={onChange}>
            {taxonomies.categories.map((category) => (
              <option key={category} value={category}>
                {category}
              </option>
            ))}
          </select>
        </label>

        <label>
          <span>Status</span>
          <select name="status" value={itemForm.status} onChange={onChange}>
            {taxonomies.statuses.map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </select>
        </label>

        <label>
          <span>Price or sale label</span>
          <input
            type="text"
            name="priceLabel"
            value={itemForm.priceLabel}
            onChange={onChange}
            placeholder="Price on request, Sold, $499..."
          />
        </label>

        <label>
          <span>Cover image URL</span>
          <input
            type="url"
            name="coverImageUrl"
            value={itemForm.coverImageUrl}
            onChange={onChange}
            placeholder="https://..."
          />
        </label>
      </div>

      <label>
        <span>Summary</span>
        <textarea
          name="summary"
          rows="3"
          value={itemForm.summary}
          onChange={onChange}
          placeholder="What does the project do, and why does it matter?"
        />
      </label>

      <label>
        <span>Impact</span>
        <textarea
          name="impact"
          rows="3"
          value={itemForm.impact}
          onChange={onChange}
          placeholder="Operational impact, user value, business result..."
        />
      </label>

      <label>
        <span>Description</span>
        <textarea
          name="description"
          rows="3"
          value={itemForm.description}
          onChange={onChange}
          placeholder="Extra notes, implementation detail, or product context."
        />
      </label>

      <label>
        <span>Build instructions or implementation notes</span>
        <textarea
          name="buildInstructions"
          rows="3"
          value={itemForm.buildInstructions}
          onChange={onChange}
          placeholder="How to build it, how the device is wired, how to run the code, or what someone gets from GitHub."
        />
      </label>

      <label>
        <span>Availability note</span>
        <textarea
          name="availabilityNote"
          rows="2"
          value={itemForm.availabilityNote}
          onChange={onChange}
          placeholder="Available as custom build, licensing note, private client work..."
        />
      </label>

      <div className="studio-form-grid">
        <label>
          <span>Technologies</span>
          <input
            type="text"
            value={itemForm.technologiesInput}
            onChange={(event) => onArrayFieldChange('technologiesInput', event.target.value)}
            placeholder="React, Flask, ESP32, OpenAI"
          />
        </label>

        <label>
          <span>Platforms</span>
          <input
            type="text"
            value={itemForm.platformsInput}
            onChange={(event) => onArrayFieldChange('platformsInput', event.target.value)}
            placeholder="Web, Android, Embedded"
          />
        </label>

        <label>
          <span>Tags</span>
          <input
            type="text"
            value={itemForm.tagsInput}
            onChange={(event) => onArrayFieldChange('tagsInput', event.target.value)}
            placeholder="iot, chatbot, payments"
          />
        </label>

        <label className="checkbox-field">
          <input
            type="checkbox"
            name="featured"
            checked={itemForm.featured}
            onChange={onChange}
          />
          <span>Feature this item on the public portfolio</span>
        </label>
      </div>

      <div className="studio-subpanel">
        <div className="studio-subpanel__header">
          <h4>Links</h4>
          <button type="button" className="studio-inline-button" onClick={onAddLink}>
            <FaPlus aria-hidden="true" />
            Add link
          </button>
        </div>

        <div className="studio-stack">
          {itemForm.links.map((link, index) => (
            <div key={`link-${index}`} className="studio-row-card">
              <div className="studio-form-grid">
                <label>
                  <span>Label</span>
                  <input
                    type="text"
                    value={link.label}
                    onChange={(event) => onLinkChange(index, 'label', event.target.value)}
                    placeholder="Live demo, APK, Repo..."
                  />
                </label>

                <label>
                  <span>URL</span>
                  <input
                    type="url"
                    value={link.url}
                    onChange={(event) => onLinkChange(index, 'url', event.target.value)}
                    placeholder="https://..."
                  />
                </label>

                <label>
                  <span>Type</span>
                  <select
                    value={link.type}
                    onChange={(event) => onLinkChange(index, 'type', event.target.value)}
                  >
                    {taxonomies.linkTypes.map((type) => (
                      <option key={type} value={type}>
                        {type}
                      </option>
                    ))}
                  </select>
                </label>
              </div>

              <button
                type="button"
                className="studio-inline-button studio-inline-button--danger"
                onClick={() => onRemoveLink(index)}
              >
                <FaTrashAlt aria-hidden="true" />
                Remove link
              </button>
            </div>
          ))}
        </div>
      </div>

      <div className="studio-subpanel">
        <div className="studio-subpanel__header">
          <h4>Videos</h4>
          <button type="button" className="studio-inline-button" onClick={onAddVideo}>
            <FaPlus aria-hidden="true" />
            Add video
          </button>
        </div>

        <div className="studio-stack">
          {itemForm.videos.map((video, index) => (
            <div key={`video-${index}`} className="studio-row-card">
              <div className="studio-form-grid">
                <label>
                  <span>Title</span>
                  <input
                    type="text"
                    value={video.title}
                    onChange={(event) => onVideoChange(index, 'title', event.target.value)}
                    placeholder="Demo walkthrough"
                  />
                </label>

                <label>
                  <span>Video URL</span>
                  <input
                    type="url"
                    value={video.url}
                    onChange={(event) => onVideoChange(index, 'url', event.target.value)}
                    placeholder="https://youtube.com/..."
                  />
                </label>
              </div>

              <button
                type="button"
                className="studio-inline-button studio-inline-button--danger"
                onClick={() => onRemoveVideo(index)}
              >
                <FaTrashAlt aria-hidden="true" />
                Remove video
              </button>
            </div>
          ))}
        </div>
      </div>

      <div className="studio-actions">
        <button type="submit" className="studio-button" disabled={busy}>
          {busy ? 'Saving...' : isEditing ? 'Update item' : 'Create item'}
        </button>
        <button type="button" className="studio-button studio-button--ghost" onClick={onReset}>
          Reset form
        </button>
      </div>
    </form>
  );
}

export default StudioItemForm;
